import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/service/language.service'; 
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [MessageService]
})

export class NavbarComponent implements OnInit, OnDestroy {
  private subscripciones: Subscription = new Subscription();

  items: MenuItem[] = [];
  itemsOperador: MenuItem[] = [];
  tabitems: MenuItem[] = [];
  operador: MenuItem[] = [];
  activeItem!: MenuItem;
  rightSideBar: boolean = false;

  passwordRestore: boolean | undefined

  idrol!: number;
  nameUser: string = "";
  nameRol: string = "";
  currentLang: string = 'default'; 
  languages = [
    { label: 'Español', value: 'es', icon: 'fas fa-flag' },
    { label: 'English', value: 'en', icon: 'fas fa-flag-usa' }
  ];
   private languageChanged: boolean = false; 

  rol = [
    { name: 'Administrador', value: 1 },
    { name: 'Supervisor', value: 2 },
    { name: 'Operador', value: 3 }
  ]
  

  constructor(
      private router: Router,
      private loginservice: LoginService, 
      public messageService: MessageService,
      private route: ActivatedRoute, 
      private languageService: LanguageService,
      private cdr: ChangeDetectorRef,
      private translate: TranslateService){
      this.passwordRestore = loginservice.chatCrmUser.passwordRestore;
      this.loginservice.restorePassword$.subscribe((status) => {
        this.passwordRestore = status;
      });
      this.subscripciones.add(
        loginservice.fechaObs.subscribe(fechaActual => {
          loginservice.compararTiempoSesion(fechaActual);
        })
      );
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
  }

  ngOnDestroy(): void {
    this.subscripciones.unsubscribe();
  }

  ngOnInit() {
    if(this.passwordRestore === undefined){
      this.passwordRestore = false;
      this.languages = this.languages.filter(lang => lang.value !== 'default');
    }

    this.idrol = this.loginservice.chatCrmUser.idRol;
    const rolName = this.rol.filter(element => element.value == this.idrol);
    this.nameRol=rolName[0].name
    this.nameUser = this.loginservice.chatCrmUser.user;
    this.createItems();
    this.createItemsOperador();
    this.createTabItems();
    this.createOperador();

    for (let i = 0; i < this.tabitems.length; i++) {
      if (this.tabitems[i].label?.toLowerCase() === window.location.href.split("/")[window.location.href.split("/").length - 1]) {
        this.activeItem = this.tabitems[i]
        break;
      }
    }
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'] || this.languageService.getLanguage() || 'es';
      this.currentLang = lang;
      this.languageService.setLanguage(lang);
      this.translate.use(lang);
    });
    
    this.translate.onLangChange.subscribe(() => {
      this.createItems(); // Volver a cargar cuando cambie el idioma
    });

  }

  private createItems() {
    this.translate.get(['OPTIONS', 'DEVICES_NAV', 'CHATS_NAV', 'ERROR_PASSWORD', 'LOG_OUT']).subscribe(translations => {
      this.items = [
        {
          label: translations['OPTIONS'],
          icon: 'pi pi-user',
          command: () => {
            this.router.navigate(['/account'], { queryParamsHandling: 'merge' });
          }
        },
        {
          label: translations['DEVICES_NAV'],
          icon: 'pi pi-comment',
          command: () => {
            if (!this.passwordRestore) {
              this.router.navigate(['/devices'], { queryParamsHandling: 'merge' });
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: translations['ERROR_PASSWORD'] });
            }
          }
        },
        {
          label: translations['CHATS_NAV'],
          icon: 'pi pi-comments',
          command: () => {
            if (!this.passwordRestore) {
              this.router.navigate(['/chat'], { queryParamsHandling: 'merge' });
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: translations['ERROR_PASSWORD'] });
            }
          }
        },
        {
          label: translations['LOG_OUT'],
          icon: 'pi pi-external-link',
          command: () => {
            if (!this.passwordRestore) {
              this.loginservice.cerrarSesion();
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: translations['ERROR_PASSWORD'] });
            }
          }
        }
      ];
    });
  }
  

  private createItemsOperador(){
    this.itemsOperador = [{
      label: this.translate.instant('ACCOUNT'),
      icon: 'pi pi-user',
      command: () => {
        this.router.navigate(['/account'], { queryParamsHandling: 'merge' })
      }
    },
    {
      label: 'Chats',
      icon: 'pi pi-comments',
      command: () => {
        if(this.passwordRestore === false){
          this.router.navigate(['/chat'], { queryParamsHandling: 'merge' })
        }else{
          this.router.navigate(['account'])
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
          return;
        }
      }
    },
    {
      label: this.translate.instant('LOG_OUT'),
      icon: 'pi pi-external-link',
      command: () => {
        if(this.passwordRestore === false){
          this.loginservice.cerrarSesion();
        }else{
          this.router.navigate(['account'])
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
          return;
        }
      }
    }
    ];
  }

  private createTabItems(){
    this.translate.get(['DASHBOARD_NAV', 'CHATS_NAV', 'DEVICES_NAV', 'ACCOUNT_NAV', 'USERS_NAV', 'SETTINGS_NAV', 'CAMPAIGNS_NAV']).subscribe((translations: any) => {
    this.tabitems = [
      {
        label: translations['DASHBOARD_NAV'], icon: 'pi pi-fw pi-home',
        command: () => {
          if(this.passwordRestore === false){
            this.router.navigate(['/dashboard'], { queryParamsHandling: 'merge' })
          }else{
            this.router.navigate(['account'])
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
            return;
          }
        }
      },
      {
        label: translations['CHATS_NAV'], icon: 'pi pi-fw pi-comment',
        command: () => {
          if(this.passwordRestore === false){
            this.router.navigate(['/chat'], { queryParamsHandling: 'merge' })
          }else{
            this.router.navigate(['account'])
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
            return;
          }
        }
      },
      {
        label: translations['DEVICES_NAV'], icon: 'pi pi-fw pi-phone',
        command: () => {
            if (this.passwordRestore === false) {
              this.router.navigate(['/devices'], { queryParamsHandling: 'merge' });
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
              return;
            }
          }
        },
        {
          label: translations['ACCOUNT_NAV'],
          icon: 'pi pi-fw pi-user',
          command: () => {
            this.router.navigate(['/account'], { queryParamsHandling: 'merge' });
          }
        },
        {
          label: translations['USERS_NAV'],
          icon: 'pi pi-fw pi-users',
          command: () => {
            if (this.passwordRestore === false) {
              this.router.navigate(['/users'], { queryParamsHandling: 'merge' });
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
              return;
            }
          }
        },
        {
          label: translations['SETTINGS_NAV'],
          icon: 'pi pi-fw pi-cog',
          command: () => {
            if (this.passwordRestore === false) {
              this.router.navigate(['/settings'], { queryParamsHandling: 'merge' });
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
              return;
            }
          }
        },
        {
          label: translations['CAMPAIGNS_NAV'],
          icon: 'pi pi-send',
          command: () => {
            if (this.passwordRestore === false) {
              this.router.navigate(['/campaigns'], { queryParamsHandling: 'merge' });
            } else {
              this.router.navigate(['account']);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
              return;
            }
          }
        }
      ];
    });
  }

  private createOperador(){
    this.operador = [
      {
        label: 'Chats', icon: 'pi pi-fw pi-comment',
        command: () => {
          if(this.passwordRestore === false){
            this.router.navigate(['/chat'], { queryParamsHandling: 'merge' })
          }else{
            this.router.navigate(['account'])
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_PASSWORD') });
            return;
          }
        }
      },
      {
        label: this.translate.instant('ACCOUNT'), icon: 'pi pi-fw pi-user',
        command: () => {
          this.router.navigate(['/account'], { queryParamsHandling: 'merge' })
        }
      },
    ];
  }

  onPasswordRestoreChanged(status: boolean) {
    this.passwordRestore = status;
  }

  rightSB(): void {
    this.rightSideBar = true
  }
  changeLanguage(lang: string): void {
    if (!lang || lang === this.currentLang) {
      return;
    }
    // 1) Guarda el nuevo idioma
    this.currentLang = lang;
    this.languageService.setLanguage(lang);
    this.translate.use(lang);
    //Actualiza la URL globalmente (no hace falta relativeTo)
    this.router.navigate([], {
      queryParams: { lang },
      queryParamsHandling: 'merge'
    });

    //Refresca menús si los estás traduciendo a mano
    this.createItems();
    this.createTabItems();
    // Si usas ChangeDetectionStrategy.OnPush podrías necesitar:
    this.cdr.markForCheck();
  }
  
}
